import { css, Global } from '@emotion/react';
import { Tooltip, type TooltipProps } from '@ui/tooltip';
import { rem } from '@utils';
import type { PropsWithChildren, ReactNode } from 'react';
import { Fragment } from 'react';
import Styled from './Chip.styled';

interface Props extends PropsWithChildren {
  color?: string;
  className?: string;
  icon?: ReactNode;
  tooltip?: ReactNode;
}

function Chip(props: Props) {
  const content = (
    <Styled.Content
      className={props.className ? `${props.className}-content` : undefined}>
      {props.icon}
      <span>{props.children}</span>
    </Styled.Content>
  );

  const chipInner = props.tooltip ? (
    <Tooltip
      {...tooltipProps}
      classesTooltip="chip-tooltip"
      className="chip-tooltip-anchor"
      data-testid="chip-tooltip-anchor"
      content={props.tooltip}>
      {content}
    </Tooltip>
  ) : (
    content
  );

  return (
    <Fragment>
      <Global styles={styles} />
      <Styled.Wrapper
        className={props.className}
        color={props.color}
        hasTooltip={!!props.tooltip}>
        {chipInner}
      </Styled.Wrapper>
    </Fragment>
  );
}

const tooltipProps: TooltipProps = {
  content: null,
  children: null,
  enterDelay: 150,
  enterNextDelay: 150,
  enterTouchDelay: 350,
  leaveDelay: 200,
  leaveTouchDelay: 4000,
  variant: 'white'
};

const styles = css`
  .chip-tooltip {
    && {
      max-width: var(--chip-max-width);
      margin: ${rem(8)} auto !important;
      padding: ${rem(16)};
    }
  }
`;

export default Chip;
